export default __webpack_public_path__ + "static/media/Group 3398@2x.b9ccdb26.png";